import { AuditSocialMediaPostController } from './audit-social-media-post.controller'

function auditSocialMediaPost () {
  return {
    restrict: 'E',
    scope: {
      post: '<'
    },
    templateUrl: '/audit/directives/audit-social-media-post/audit-social-media-post.html?$$REVISION$$',
    controller: AuditSocialMediaPostController
  }
}

export { auditSocialMediaPost }
